import { getApiUrl, RECRUITER_API_URL } from '../../util/api/api'
import type { UserInfoOutgoing } from '../../../state/reducers/user/user'
import { StatusCodes } from 'http-status-codes'

const updateRecruiterInfo = async (user: UserInfoOutgoing) => {
  const fetchResponse = await fetch(
    getApiUrl(RECRUITER_API_URL), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify(user),
    }
  )
  
  if (fetchResponse?.ok) {
    return Promise.resolve({ status: StatusCodes.ACCEPTED })
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}
export default updateRecruiterInfo
